/**
 * Activities and Attractions Section Component
 * Displays activities with icons in a grid format
 */

import React from 'react';

/** Derive a stable slug from label for icon lookup when API does not provide id */
function slugFromLabel(label: string): string {
  return label
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}
import { spacing } from '@/design-system/utils';
import { SectionHeader } from '@/components/ui/section-header';
import { IconItemList, IconItem } from './IconItemList';

export interface ActivityItem {
  id?: string;
  icon: string | null;
  label: string;
}

export interface ActivitiesAndAttractionsSectionProps {
  title: string;
  activities: ActivityItem[];
}

export const ActivitiesAndAttractionsSection: React.FC<
  ActivitiesAndAttractionsSectionProps
> = ({ title, activities }) => {
  if (!activities || activities.length === 0) {
    return null;
  }

  // Map ActivityItem to IconItem (pass id so each item can resolve to a distinct icon)
  const iconItems: IconItem[] = activities.map((activity, index) => ({
    id: activity.id || slugFromLabel(activity.label),
    label: activity.label,
    icon: activity.icon,
    key: activity.id || `${activity.label}-${index}`,
  }));

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <SectionHeader title={title} />
      <div
        style={{
          marginTop: spacing[3],
          padding: `${spacing[3]}px ${spacing[3]}px`,
        }}
      >
        <IconItemList
          items={iconItems}
          iconSize={20}
          iconType='activity'
          mobileColumns={2}
          desktopColumns={3}
          rowGap={spacing[4]}
          columnGap={spacing[6]}
        />
      </div>
    </div>
  );
};
